import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum AssetSecurityRight {
    CanAccess = 18000,
    Manage = 18001,
    CanAccessCustomerAssets = AssetSecurityRight.CanAccess,
    CanAccessCompanyAssets = 18002,
    ManageCustomerAssets = AssetSecurityRight.Manage,
    ManageCompanyAssets = 18003,
}

export class AssetSecurityModule extends BaseSecurityModule<AssetSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Assets,
            [
                { _id: AssetSecurityRight.CanAccessCustomerAssets, name: 'Access Customer Assets', basic: true },
                { _id: AssetSecurityRight.CanAccessCompanyAssets, name: 'Access Company Assets', basic: true },

                { _id: AssetSecurityRight.ManageCustomerAssets, name: 'Manage Customer Assets', basic: true },
                { _id: AssetSecurityRight.ManageCompanyAssets, name: 'Manage Company Assets', basic: true },
            ] as SecurityRight<AssetSecurityRight>[],
        );

        this.plan = TenantSubscription.Custom;
    }


}
